import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
//3:34:00

class AddTask extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      taskDesc: ''
    };
  }

  handleTaskTextChange(e){
    this.setState({
      taskDesc: e.target.value
    });
  }

  handleAddTaskClick(){
    this.props.handlerToCollectTaskInfo(this.state.taskDesc);
    this.setState({
      taskDesc: ''
    });
  }

  render(){
    return(
      <form>
          <input type="text" value={this.state.taskDesc} onChange={(e) => this.handleTaskTextChange(e)} />
          <input type="button" value="Add Task" onClick={() => this.handleAddTaskClick()}/>
      </form>
    )
  }
}

class TaskList extends React.Component {

  handleTaslClick(task){
    this.props.handlerToCollectTaskClickInfo(task);
  }
  render(){
    let list = [];

    for(let i=0;i<this.props.tasks.length;i++){
      let task = this.props.tasks[i];
      let spanAction;

      if(task.isFinished){
        spanAction = (
          <span class="material-icons" onClick={() => this.handleTaslClick(task.desc)}>close</span>
        );
      } else {
        spanAction = (
          <span class="material-icons" onClick={() => this.handleTaslClick(task.desc)}>done</span>
        );
      }

      let listItem =( 
              <div key={i}>
                  <span>{task.desc}  </span>
                  {spanAction}
              </div>
              );
      list.push(listItem);
    }

    return(
        <div className={this.props.forstyling}>
        <div className='list-container'>
          <div className='title'>{this.props.purpose}</div>
          <div className='content'>
              {list}
          </div>
        </div>
        </div>
    )
  }
}

class App extends React.Component {

  constructor(props){
    super(props);

    this.state = {
      tasks: []
    }
  }

  handleNewTask(task){
    let oldTasks = this.state.tasks.slice();
    oldTasks.push({
      desc: task,
      isFinished: false 
    });
    this.setState({
      tasks: oldTasks
    })
  }

  handleTaskStatusUpdate(taskDesc, newStatus){
    let oldTasks = this.state.tasks.slice();

    let taskItem = oldTasks.find(ot => ot.desc ===  taskDesc);
    taskItem.isFinished = newStatus;

    this.setState({
      tasks: oldTasks
    })
  }

  render(){
    // const name = "Yash";
    let tasks = this.state.tasks;
    let todoTasks = tasks.filter(t => t.isFinished === false);
    let doneTasks = tasks.filter(t => t.isFinished === true);
    return(
      // <h1>Hello {name}</h1>
      
      <>
        <div className='add-task'>
            <AddTask handlerToCollectTaskInfo={(taskDesc) => this.handleNewTask(taskDesc)} />
        </div>
        
        <div className='task-lists'>
            <TaskList handlerToCollectTaskClickInfo={ (taskDesc) => this.handleTaskStatusUpdate(taskDesc, true)} tasks={todoTasks} purpose="Todo" forstyling="todo" />
            <TaskList handlerToCollectTaskClickInfo ={ (taskDesc) => this.handleTaskStatusUpdate(taskDesc, false)}  tasks={doneTasks} purpose="Finished" forstyling="finished"  />
        </div> 
      </>
    );
  }
}

ReactDOM.render(<App />,document.getElementById("root"));
